import { render, staticRenderFns } from "./Portrait.vue?vue&type=template&id=acc030fe&scoped=true&"
import script from "./Portrait.vue?vue&type=script&lang=js&"
export * from "./Portrait.vue?vue&type=script&lang=js&"
import style0 from "./Portrait.vue?vue&type=style&index=0&id=acc030fe&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acc030fe",
  null
  
)

export default component.exports